import DomainMaps from '@/maps/domainMaps'

const { appDomain, youpinApiDomain } = DomainMaps

const state = {
  skuParamsList: [],
  curSkuPopupId: '',
  mysku: '',
  selectSkuParamsText: '',
  cartInfoCount: 0,
  commentListInfo: null,
  // baseInfo接口
  prodBase: {},
  bannerPics: [],
  promotionInfo: [],
  liveVo: null,
  actInfoVo: null,
  brandInfoVo: null,
  expressInfo: null,
  coupons: [],
  afterSaleInfo: [],
  titleBottomInfo: null,
  handPriceVo: null,
  // moreInfo接口
  faqs: [],
  adInfoVo: null,
  introPics: [],
  report: null,
  zyShop: null,
  recommend: [],
  sellerInfo: null,
  // skuStore接口
  paramList: [],
  curSkuKey: '',
  installmentInfo: {}, // 分期信息
  isFromFinance: false,
  showCouponPopup: false,
  couponTips: {}
}

const actions = {
  initBaseInfo({ commit }, payload) {
    commit('SET_BASE_INFO', payload)
  },
  async getBaseInfo({ dispatch }, params) {
    try {
      const res = await this.$axios.$get(`${appDomain}/zzopen/ypmall/baseInfo`, {
        params
      })
      dispatch('initBaseInfo', res)
    } catch (error) {
      console.log(error)
    }
  },
  async getCommentListInfo({ commit }, params) {
    try {
      const res = await this.$axios.$get(`${appDomain}/zzopen/yporder/getCommentList`, {
        params
      })
      commit('SET_COMMENT_LIST_INFO', res)
    } catch (err) {
      console.log(err)
    }
  },
  async getMoreInfo({ commit }, params) {
    try {
      const res = await this.$axios.$get(`${appDomain}/zzopen/ypmall/moreInfo`, {
        params
      })
      commit('SET_MORE_INFO', res || {})
    } catch (err) {
      console.log(err)
    }
  },
  async getSkuStore({ commit }, params) {
    try {
      const res = await this.$axios.$get(`${appDomain}/zzopen/ypmall/skuStore`, {
        params
      })
      commit('SET_SKU_PARAMS_LIST', res || {})
    } catch (err) {
      console.log(err)
    }
  },
  getCartInfoCount({ commit }) {
    this.$axios
      .$get(`${appDomain}/zz/transfer/getInfoItemsCountHttp`)
      .then((res) => {
        commit('SET_CARD_INFO_COUNT', res.count)
      })
      .catch((err) => {
        console.log(err)
      })
  },
  async getCouponTips({ commit }) {
    try {
      const res = await this.$axios.$get(`${youpinApiDomain}/goods/coupon/pendant`)
      commit('SET_COUPON_TIPS', res || {})
    } catch (err) {
      console.log(err)
    }
  },
  async getInstallmentInfo({ commit }, params) {
    try {
      const res = await this.$axios.$get(`${youpinApiDomain}/goods/mall/stages/filter/info`, {
        params
      })
      commit('SET_INSTALLMENT_INFO', res || {})
    } catch (error) {
      console.log(error)
    }
  }
}

const mutations = {
  SET_BASE_INFO(state, v) {
    // console.log(v)
    const {
      pics,
      promotionInfo,
      liveVo,
      actInfoVo,
      brandInfoVo,
      expressInfo,
      coupons,
      afterSaleInfo,
      titleBottomInfo,
      handPriceVo,
      ...baseInfo
    } = v
    state.prodBase = baseInfo
    state.bannerPics = pics
    state.promotionInfo = promotionInfo
    state.liveVo = liveVo
    state.actInfoVo = actInfoVo
    state.brandInfoVo = brandInfoVo
    state.expressInfo = expressInfo
    state.coupons = coupons
    state.afterSaleInfo = afterSaleInfo
    state.titleBottomInfo = titleBottomInfo
    state.handPriceVo = handPriceVo
  },
  SET_MORE_INFO(state, v) {
    const { faqs, adInfoVo, introPics, report, zyShop, recommend, sellerInfo } = v
    state.faqs = faqs
    state.adInfoVo = adInfoVo
    state.introPics = introPics
    state.report = report
    state.zyShop = zyShop
    state.recommend = recommend
    state.sellerInfo = sellerInfo
  },
  SET_SKU_PARAMS_LIST(state, v = []) {
    state.skuParamsList = v.reduce((pre, param) => {
      if (!Array.isArray(param.list) || !param.list.length) {
        return pre
      } else {
        return pre.concat({
          id: param.itemId,
          name: param.itemValue,
          items: param.list.map((item) => {
            const obj = { name: item.name, id: item.id }
            if (['6978:1080627|6982:1080635', '6978:1080627|6982:1080636'].indexOf(item.id) > -1) {
              return Object.assign(obj, {
                desc: '不论是否过了苹果官方保修期，均享受转转自营提供的180天质保'
              })
            } else if (['1080697'].indexOf(item.id) > -1) {
              return Object.assign(obj, {
                desc: '拍照有声音且无法关闭，手机硬件设备无差别'
              })
            }
            return obj
          })
        })
      }
    }, [])
  },
  SET_COMMENT_LIST_INFO(state, v) {
    state.commentListInfo = v
  },
  SET_MY_SKU(state, v) {
    state.mysku = v
  },
  SET_CUR_SKU_POPUP_ID(state, v) {
    state.curSkuPopupId = v
  },
  SET_SELECT_SKU_PARAMS_TEXT(state, v) {
    state.selectSkuParamsText = v
  },
  SET_CARD_INFO_COUNT(state, v) {
    state.cartInfoCount = v
  },
  SET_INSTALLMENT_INFO(state, v) {
    state.installmentInfo = v
  },
  SET_COUPON_TIPS(state, v) {
    state.couponTips = v
  },
  /* eslint-disable */
  SET_CHANGE_INSTALLMENT_INFO(state, v) {
    state.installmentInfo?.items.map((item, index) => {
      item.isDefault = v === index ? !item.isDefault : false
    })
  },
  SET_SKU_INSTALLMENT_INFO(state, v) {
    state.installmentInfo?.items.map((item, index) => {
      if (item.isDefault && v === index) return
      item.isDefault = v === index ? !item.isDefault : false
    })
  },
  /* eslint-disable */
  SET_IS_FROM_FINANCE(state, v) {
    state.isFromFinance = v
  },
  SET_COUPON_POPUP(state, v) {
    state.showCouponPopup = v
  }
}

const getters = {
  getCateLastId: (state) => state.prodBase?.cateLastId,
  getCate: (state) => state.prodBase?.cateFirstId,
  getFilterStr: (state) => state.prodBase?.subscribeStr,
  getPayType: (state) => state.installmentInfo?.payType,
  getStageId: (state) => state.installmentInfo?.items?.find((item) => item.isDefault)?.term,
  getCollected: (state) => state.prodBase?.collected
}
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
